import {PageIllustration} from '../../illustrations';
import {cn} from '../../lib/utils';

import type {ReactNode} from 'react';

export const EXT_COLORS: Record<string, string> = {
  PDF: 'bg-destructive',
  DOC: 'bg-brand-primary',
  DOCX: 'bg-brand-primary',
  XLS: 'bg-brand-primary',
  XLSX: 'bg-brand-primary',
  PNG: 'bg-brand-primary',
  JPG: 'bg-brand-primary',
  JPEG: 'bg-brand-primary'
};

export interface FileIconProps {
  ext: string;
  size?: 'sm' | 'md';
}

const namedSizes = {
  sm: 'size-6',
  md: 'size-10'
} as const;

const labelTextSizes = {
  sm: 'text-[6px]',
  md: 'text-[10px]'
} as const;

export function FileIcon({ext, size = 'md'}: FileIconProps): ReactNode {
  const badgeColor = EXT_COLORS[ext] ?? 'bg-[oklch(0.46_0.017_263)]';

  return (
    <div className={cn('relative inline-flex shrink-0', namedSizes[size])}>
      <div className="absolute inset-[0_2.5%_0_17.5%]">
        <PageIllustration className="block h-full w-full" />
      </div>
      {ext && (
        <span
          className={cn(
            'absolute bottom-[15%] left-[2.5%] flex items-center justify-center rounded-[2px] py-[1.2px] px-[1.8px] text-[8px] font-bold leading-none text-white whitespace-nowrap',
            labelTextSizes[size],
            badgeColor
          )}
        >
          {ext.slice(0, 4)}
        </span>
      )}
    </div>
  );
}
